import AppRouter from './Router/AppRouter';
import './styles/styles.css'
import '@sweetalert2/theme-material-ui/material-ui.scss'

function App() {
  return (
  <>
    <AppRouter />
  </>
  );
}

export default App;
